import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Longest Consecutive Subsequence",
  url: "longest-consecutive-subsequence",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {Array[]} arr
* @return {Number}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function longestConsecutiveSubSequences(arr) {
  // your code goes here        
};
`,
};

export default info;
